var a={tagsLabel:"tagsLabel__wZLyaq"};export{a as default};
